import { MoreHoriz } from "@mui/icons-material";

import EdmIconButton, { EdmIconButtonPropsType } from "./EdmIconButton";

export type MoreButtonPropsType = EdmIconButtonPropsType & {
  noBackground?: boolean;
  tooltipTitle?: string;
};

export default function MoreButton({
  noBackground = false,
  size = "large",
  tooltipTitle,
  ...props
}: MoreButtonPropsType) {
  return (
    <EdmIconButton variant={noBackground ? "text" : "contained"} size={size} tooltipTitle={tooltipTitle} {...props}>
      <MoreHoriz />
    </EdmIconButton>
  );
}
